var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCocktailIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.092 2.96185C21.9636 2.20766 21.3463 0.918518 20.1138 0.918518H1.88641C0.653894 0.918518 0.0366085 2.20766 0.90819 2.96185L9.68758 10.5548V17.3787H7.39071C6.48467 17.3787 5.75008 18.0141 5.75008 18.7977C5.75008 18.9545 5.89692 19.0815 6.07821 19.0815H15.922C16.1032 19.0815 16.2501 18.9545 16.2501 18.7977C16.2501 18.0141 15.5155 17.3787 14.6095 17.3787H12.3126V10.5548L21.092 2.96185Z",
    fill: "#EAE6D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocktailIcon);
export default __webpack_public_path__ + "static/media/cocktail-icon.0949585877997f981c28eb67b1812380.svg";
export { ForwardRef as ReactComponent };